import React, { Component } from "react";
import axios from "axios";
import $ from "jquery";
import Headers from "../Layouts/Headers";
import { config } from "../_helpers/global";
import { MDBDataTable } from "../_mdbcomponents/components/DataTable/DataTable";
import Loader from "../Layouts/Loader";
import { InterModularSidebar } from "../Layouts/InterModularSidebar";

export class AllTreatment extends Component {
  constructor(props) {
    super(props);

   

    const url = "";
    this.state = {
      visitid: "",
      DataLoaded: false,

      prescriptionserial: "",
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleRowClick(patient) {
    console.log(patient);
    localStorage.removeItem("prescriptionserialnumber");
    localStorage.setItem(
      "prescriptionserialnumber",
      patient["prescriptionserial"]
    );
    console.log(localStorage.getItem("prescriptionserialnumber"));
    if (localStorage.getItem("currentSpecialty") == "nurse") {
      window.location.href = "/single/treatment";
    } else {
      console.log(Object.keys(patient));

      for (var i = 0; i < Object.keys(patient).length; i++) {
        $("." + Object.keys(patient)[i]).html(
          "<b>" +
            Object.keys(patient)[i] +
            "</b>: " +
            patient[Object.keys(patient)[i]]
        );
      }
      $(".stoptreatment").show();
    }
  }

  componentDidMount() {
    const headers = {
      "Content-Type": "application/json",
      token: localStorage.getItem("accessToken"),
      visitid: localStorage.getItem("currentVisitId"),
      // 'visitid': localStorage.getItem('visitId')
    };
    $(".stopTreatment").on("click", function () {
      const headers = {
        "Content-Type": "application/json",
        token: localStorage.getItem("accessToken"),
        visitid: localStorage.getItem("currentVisitId"),
        // 'visitid': localStorage.getItem('visitId')
      };

      //axios.get(this.url+"/treatment/off",this.state,{ headers: headers })
      // .then(res => {
      //     console.log(res.data)

      // });
    });

    axios
      .get(this.url + "/triage/treatment/main", { headers: headers })
      .then((res) => {
        //   const verified = res.data;
        // console.log(res.data[0]['module'])
        var tableinit = new Array();
        for (var i = 0; i < res.data.length; i++) {
          console.log(res.data[i]);

          var number = i + 1;
          // console.log()

          tableinit.push(res.data[i]);

          // console.log(typeof(table))
          let object = {};
          for (let i = 0; i < tableinit.length; i++) {
            delete tableinit[i]._id;
            delete tableinit[i].timeOfRegistration;
            tableinit[i].clickEvent = () => this.handleRowClick(tableinit[i]);
          }
          // table = JSON.stringify(table);

          var table = Object.assign(tableinit);

          // alert(table)
          this.TableData = table;
          // console.log(this.TableData);
          this.setState({
            DataLoaded: true,
          });

          // var searchRow = '<tr><td>'+number+'</td> <td>'+res.data[i]['Name']+'</td><td>'+res.data[i]['Age']+'</td><td>'+res.data[i]['Profession']+'</td><td>'+res.data[i]['MaritalStatus']+'</td><td>'+res.data[i]['Address']+'</td><td>'+res.data[i]['Tel ']+'</td><td>'+res.data[i]['Nationality']+'</td><td>'+date+'</td><td>'+time+'</td><td>'+visitNumber+'</td><td>'+serialNumber+'</td><td></td><td></td><td><a className="btn btn-primary startTreatment" id="'+res.data[i]['visitid']+'">Start Treatment</a></td></tr>'
          // $('.searchClass').append(searchRow)
        }

        //   if(res.data['status'])
        //   {
        //     $('.sendModuleSuccess').show()
        //     setTimeout(function (props) {
        //         $('.modal').hide()
        //          // this.props.history.push('/reception/dashboard')
        //      }, 3000);
        //   }
      })
      .catch((error) => {
        console.log(error);
        $('#SubmitError').show();
        $(".alert-success").hide();
      });
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleSubmit = (event) => {};

  render() {
    // Complications = request.json["Complications"],
    // PregnancyDate = request.json["PregnancyDate"],
    // EvolutionAndTreatment = request.json["EvolutionAndTreatment"],

    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };

    const { Complications, PregnancyDate, EvolutionAndTreatment } = this.state;

    let { DataLoaded } = this.state;
    const tabledata = {
      columns: [
        {
          label: "Route",
          field: "Route",
          sort: "asc",
          width: 50,
        },
        {
          label: "DrugName",
          field: "DrugName",
          sort: "asc",
          width: 50,
        },
        {
          label: "Dosage",
          field: "Dosage",
          sort: "asc",
          width: 50,
        },
        {
          label: "Frequency",
          field: "Frequency",
          sort: "asc",
          width: 50,
        },
        {
          label: "Duration",
          field: "Duration",
          sort: "asc",
          width: 50,
        },
        {
          label: "Drug Administration",
          field: "DrugAdministration",
          sort: "asc",
          width: 50,
        },
        {
          label: "midwife nursename",
          field: "midwifenursename",
          sort: "asc",
          width: 50,
        },

        {
          label: "Remarks",
          field: "remarks",
          sort: "asc",
          width: 50,
        },
        // {
        //     label: "Action",
        //     field: "EvolutionAndTreatment",
        //     sort: "asc",
        //     width: 50
        // },
      ],
      rows: this.TableData,
    };
    return (
      <div>
        <Headers />

        <InterModularSidebar />

        <main>
          <div className="container p-2">
            <form>
              <div className="form-row pt-4">
                <div className="col-md-4 text-lg-center font-weight-bold p-1">
                  <p className="text-capitalize" style={font16}></p>
                </div>
                <MDBDataTable striped bordered data={tabledata} />
              </div>
            </form>
          </div>
        </main>
        <div className="modal stoptreatment" tabIndex="-1" role="dialog">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title patientName"> </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <p className="Route"></p>
                <p className="DrugName"></p>
                <p className="Dosage"></p>
                <p className="Frequency"></p>
                <p className="Duration"></p>
                <p className="DrugAdministration"></p>
                <p className="midwifenursename"></p>
                <p className="remarks"></p>
                <button className="btn btn-success stopTreatment">
                  Stop Treatment
                </button>
                <div
                  id="loginSuccess"
                  className="alert alert-success"
                  style={displayHidden}
                  role="alert"
                >
                  <strong>Success! </strong>Treatment Started Successfully
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AllTreatment;
